import { Injectable } from "@angular/core";
import { Subject, fromEvent, merge } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: "root",
})
export class UserIdleTimeOutService {
  private timeout = 15 * 60 * 1000; // 15 mins
  private timer: any;

  // 🔥 notify component
  public autoLogout$ = new Subject<void>();

  constructor(private toastr: ToastrService) {
    this.startWatching();
  }

  // ---------------------------------------
  // Watch user activity (mouse/keyboard)
  // ---------------------------------------
  startWatching() {
    const events$ = merge(
      fromEvent(document, "mousemove"),
      fromEvent(document, "keydown"),
      fromEvent(document, "click"),
      fromEvent(document, "scroll"),
    );

    events$.pipe(debounceTime(300)).subscribe(() => {
      this.resetTimer();
    });

    this.resetTimer();
  }

  // ---------------------------------------
  // Reset timer
  // ---------------------------------------
  resetTimer() {
    clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      this.toastr.warning("Session Timeout");
      this.autoLogout$.next(); // 🔥 trigger logout
    }, this.timeout);
  }
}
